import axios from '@/axios/globalaxios'

// 修改密码
export const modifyPasswordInterface = data =>{
  return axios({
      url: "/tradelab/sysUser/updatePassword",
      method: 'post',
      data:data
  })
}